import { forwardRef, useState } from 'react';
import {
  MenuItem,
} from '@mui/material';
import LessonPlay from '../../../lessonplay/LessonPlay';
import { useTrackTeacherActivityPreview } from '../hooks/TeacherTrackingActivityHooks';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lesson: {},
  onClick: () => { },
  user: null,
  userProfile: null,
  terminologies: {},
  onLessonFinished: () => { },
};

const LessonPreviewMenuItem = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onClick, lesson, user, userProfile, terminologies, onLessonFinished } = mergedProps;
  const [open, setOpen] = useState(false);

  useTrackTeacherActivityPreview(open, user, lesson);

  const handleOnClick = () => {
    onClick();
    setOpen(true);
  };

  return (
    <>
      <MenuItem onClick={handleOnClick} ref={ref} tabIndex={0}>Preview</MenuItem>
      {open && (
        <LessonPlay
          open={open}
          handleClose={() => { setOpen(false); }}
          lesson={lesson}
          isPreviewMode
          user={user}
          userProfile={userProfile}
          terminologies={terminologies}
          onLessonFinished={onLessonFinished}
        />
      )}
    </>
  );
});

export default LessonPreviewMenuItem;
